import { useEffect } from 'react';
import { ErrorSummaryPanel } from '../../components/CarValuationPage/components/ErrorSummaryPanel/ErrorSummaryPanel';
import {
  PageWrapper,
  HeroImage,
} from '../../components/CarValuationPage/CarValuation';
import { TCarValuationPageNames } from '../../helpers/pages';
import { pushToDataLayer } from '../../services/gtmService';

interface ICarValuationErrorPage {
  cdnUrl: string;
  registration?: string;
  pageName: TCarValuationPageNames;
}
function CarValuationErrorPage({
  cdnUrl,
  registration = '',
  pageName,
}: ICarValuationErrorPage) {
  const heroImage = `${cdnUrl}/images/hero/private-valuation-hero-mobile.png`;
  const desktopHeroImage = `${cdnUrl}/images/hero/private-valuation-hero-desktop.png`;

  useEffect(() => {
    pushToDataLayer({ event: `${pageName.replace(/-/g, '_')}_error` });
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrapper>
      <HeroImage desktopHeroImage={desktopHeroImage} heroImage={heroImage} />

      <ErrorSummaryPanel registration={registration} pageName={pageName} />
    </PageWrapper>
  );
}

export { CarValuationErrorPage };
